import AvailabilityQuickView from './availability_quick_view';

export default AvailabilityQuickView;
